import { EntityIdentifier, SearchResultParams } from './types';

export const getQueryParams = () => {
  const query = new URLSearchParams(location.search);

  return {
    searchTerm: query.get('searchTerm'),
    brand: query.get('brand'),
  } as SearchResultParams;
};

export const getProductIdentifier = (queryParams: SearchResultParams) => {
  if (queryParams.searchTerm) {
    return { name: queryParams.searchTerm } as EntityIdentifier;
  }

  if (queryParams.brand) {
    const params = queryParams.brand.split('_');

    if (params.length > 1) {
      return {
        brandId: Number.isNaN(Number(params[0]))
          ? undefined
          : Number(params[0]),
        name: params[1],
      } as EntityIdentifier;
    }

    return { name: params[1] } as EntityIdentifier;
  }
};
